import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { LANGUAGES } from "@/i18n";

export const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('lumon-lang', langCode);
  };

  return (
    <footer className="w-full border-t border-border/50 bg-background py-6 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Brand - Custom SVG Logo */}
          <img 
            src="/lumon-logo.svg" 
            alt="Lumon Peptides" 
            className="h-6 w-auto"
          />
          
          {/* Language Selector */}
          <div className="flex items-center gap-2">
            <Globe className="w-4 h-4 text-muted-foreground" />
            <div className="flex items-center gap-1">
              {LANGUAGES.map((lang) => (
                <button
                  key={lang.code}
                  onClick={() => changeLanguage(lang.code)}
                  className={`
                    px-2 py-1 rounded text-xs font-medium transition-all
                    ${i18n.language === lang.code 
                      ? "bg-primary/10 text-primary" 
                      : "text-muted-foreground hover:text-foreground hover:bg-muted"
                    }
                  `}
                >
                  <span className="mr-1">{lang.flag}</span>
                  {lang.shortName}
                </button>
              ))}
            </div>
          </div>
          
          {/* Copyright */}
          <p className="text-sm text-muted-foreground text-center">
            {t('common.copyright', { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
